import { Box, Button } from "@mui/material";
import styled from "styled-components";
import { BaseFormStyled } from "../../../../components/base-form/base-form.styles";

export const PetDetailsStyled = styled(Box)`
  .pet-details-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .no-records-found {
    display: flex;
    width: 100%;
    justify-content: center;
  }
`;

export const BaseCards = styled(BaseFormStyled)`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;

    > * {
      width: 100%;
    }
  }
`;

export const AddPetButton = styled(Button)`
  text-transform: none !important;
  height: 36px;
  background: var(--pure-white-color) !important;
  border-radius: 16px !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  color: var(--medium-gray-color) !important;
  padding: 7.5px 10px !important;
  width: 162px;
`;
